/* global $, $$ */

import datepicker from "js-datepicker"
import moment from "moment"

function arrayUnique(array) {
  const a = array.concat()
  for (let i = 0; i < a.length; ++i) {
    for (let j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) a.splice(j--, 1)
    }
  }

  return a
}

function getDates(startDate, stopDate) {
  const dateArray = []
  let currentDate = moment(startDate)
  /*  const lastDate = moment(stopDate) */
  const lastDate = Math.min(
    moment(Date.now()).add(730, "days"),
    moment(stopDate),
  )
  /* this is a quickfix, it looks only 2 years into the future otherwise it checks all events until 2099 */

  while (currentDate <= lastDate) {
    dateArray.push(moment(currentDate).unix() * 1000)
    currentDate = moment(currentDate).add(1, "days")
  }
  return dateArray
}

export function initAgenda() {
  const formCalendar = document.querySelector(".form-calendar")
  const formCalendarInputs = document.querySelectorAll(
    "[name=day]",
    formCalendar,
  )
  /* another Quick fix, use both day values */

  if (formCalendar) {
    formCalendar.addEventListener("change", () => {
      formCalendar.submit()
    })

    const dateOptions = { year: "numeric", month: "2-digit", day: "2-digit" }
    const eventElements = $$("[data-between]")

    const url = new URL(window.location)
    const selectedDate = url.searchParams.get("day")
      ? new Date(url.searchParams.get("day"))
      : null

    let activeDates = eventElements.reduce(
      (acc, el) =>
        acc.concat(
          getDates(
            el.getAttribute("data-date-start"),
            el.getAttribute("data-date-end"),
          ),
        ),
      [],
    )

    activeDates = arrayUnique(activeDates)

    const options = {
      customDays: ["S", "M", "D", "M", "D", "F", "S"],
      customMonths: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember",
      ],
      formatter: (input, date) => {
        const value = date.toLocaleDateString("fr-CA", dateOptions)
        input.value = value
      },
      startDay: 1,
      disabler: (d) => {
        return activeDates.indexOf(d.getTime()) === -1
      },
      alwaysShow: true,
      disableYearOverlay: true,
      onSelect: (_instance, selectedDate) => {
        formCalendarInputs.forEach((i) =>
          i.setAttribute(
            "value",
            selectedDate.toLocaleDateString("fr-CA", dateOptions),
          ),
        )
        formCalendar.submit()
      },
      dateSelected: selectedDate,
    }
    datepicker(formCalendarInputs[0], options)
  }
}
